var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-secondary-3 rounded mb-4 p-3" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-start mb-2" },
      [
        _c("icon-view", {
          attrs: {
            gradient: false,
            icon: "fas fa-paper-plane pr-1 pb-1",
            "icon-color": "#ff7058",
            "icon-size": "16px",
            title: "Confirmar Envío Masivo"
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
      _c("div", { staticClass: "small text-muted mr-2 text-nowrap" }, [
        _vm._v("Combinar Batches")
      ]),
      _c(
        "div",
        { staticClass: "progress w-100", staticStyle: { height: "8px" } },
        [
          _c("div", {
            staticClass: "progress-bar bg-green",
            style: { width: _vm.progressWidth },
            attrs: { role: "progressbar" }
          })
        ]
      )
    ]),
    _c("div", { staticClass: "small mb-3" }, [
      _vm._v(
        " Combinando " +
          _vm._s(_vm.batches?.length || 0) +
          " batches seleccionados en un solo envío: "
      )
    ]),
    !_vm.batches || !_vm.batches.length
      ? _c("div", { staticClass: "text-muted" }, [
          _vm._v(" No hay batches seleccionados. ")
        ])
      : _c(
          "div",
          [
            _vm._l(_vm.batches, function(b, idx) {
              return _c(
                "div",
                {
                  key: b.id || idx,
                  staticClass:
                    "row d-flex align-items-center py-3 m-1 bg-white rounded"
                },
                [
                  _c("div", { staticClass: "col d-flex align-items-center" }, [
                    _vm._m(0, true),
                    _c("div", [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Número de Batch:")
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm._f("empty")(b.number)) + " ")
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v("Lugar de Servicio:")
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("empty")(b.location?.name)))
                    ])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v("Cantidad de Reclamaciones:")
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm._f("empty")(b.count)))])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v("Monto a Reclamar:")
                    ]),
                    _c("div", [
                      _vm._v(" " + _vm._s(_vm._f("price")(b.totalAmount)) + " ")
                    ])
                  ])
                ]
              )
            }),
            _c("div", { staticClass: "row my-2 m-1" }, [
              _c("div", { staticClass: "col" }),
              _c("div", { staticClass: "col" }),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Cantidad de Reclamaciones:")
                ]),
                _c("div", [_vm._v(_vm._s(_vm._f("empty")(_vm.totalCount)))])
              ]),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Monto a Reclamar:")
                ]),
                _c("div", { staticClass: "font-weight-bold text-success" }, [
                  _vm._v(" " + _vm._s(_vm._f("price")(_vm.totalAmount)) + " ")
                ])
              ])
            ])
          ],
          2
        ),
    _c(
      "div",
      { staticClass: "d-flex justify-content-end mt-3" },
      [
        _c("action-button", {
          attrs: {
            i: "fas fa-times-circle",
            text: "Cancelar",
            variant: "outline-danger mr-3"
          },
          on: {
            click: function($event) {
              return _vm.$emit("cancel")
            }
          }
        }),
        _c("action-button", {
          attrs: {
            iright: "fas fa-chevron-circle-right",
            text: "Continuar",
            variant: "success"
          },
          on: {
            click: function($event) {
              return _vm.$emit("confirm")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c("div", { staticClass: "fas fa-check text-green" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }